import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { Utils } from "../Utils";
import { ModalUtils } from "../Components/Modal/ModalUtils";
import { inject, injectable } from "inversify";
import NeoTypes from "../AppServices/NeoTypes";
var NeoLoginErrorHandler = /** @class */ (function () {
    function NeoLoginErrorHandler(authenticationService, navigationHelper) {
        this.authenticationService = authenticationService;
        this.navigationHelper = navigationHelper;
    }
    NeoLoginErrorHandler.prototype.onMissingLoginState = function () {
        if (this.authenticationService.isAuthenticated) {
            this.onAlreadyLoggedIn();
        }
        else {
            this.onNotLoggedIn();
        }
    };
    NeoLoginErrorHandler.prototype.onException = function (error) {
        var errorMessage = "";
        if (error instanceof Error) {
            errorMessage = error.message;
        }
        else {
            errorMessage = error;
        }
        if (errorMessage.indexOf("exp is in the past") >= 0) {
            this.onIncorrectUserClock();
        }
        else {
            this.onUnhandledException(errorMessage);
        }
    };
    NeoLoginErrorHandler.prototype.onAlreadyLoggedIn = function () {
        var _this = this;
        var userName = this.authenticationService.user.displayName;
        var displayHtml = Utils.suppressHtmlEncode("<p>You are attempting to login, but are already logged in as ".concat(userName, ".</p><p>Do you want to continue as ").concat(userName, ", or logout?</p>"));
        ModalUtils.showModal("Login", displayHtml, {
            acceptButton: { text: "Continue", icon: "arrow-right", onClick: function () { return _this.redirectToHome(); } },
            closeButton: { text: "Logout", icon: "sign-out-alt", onClick: function () { _this.authenticationService.beginSignOut(); } },
            showCancelButton: false
        });
    };
    NeoLoginErrorHandler.prototype.onNotLoggedIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Old login request
                    return [4 /*yield*/, ModalUtils.showMessage("Old login request", "You are using an old login request. Click ok to login again.")];
                    case 1:
                        // Old login request
                        _a.sent();
                        // Redirect to home page. This will cause a login redirect if the home page requires authentication.
                        this.redirectToHome();
                        return [2 /*return*/];
                }
            });
        });
    };
    NeoLoginErrorHandler.prototype.onIncorrectUserClock = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ModalUtils.showMessage("Login", "Login request expired. This is most likely due to your device's time being incorrect.")];
                    case 1:
                        _a.sent();
                        this.redirectToHome();
                        return [2 /*return*/];
                }
            });
        });
    };
    NeoLoginErrorHandler.prototype.onUnhandledException = function (errorMessage) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ModalUtils.showMessage("Login", "An error occurred: " + errorMessage)];
                    case 1:
                        _a.sent();
                        this.redirectToHome();
                        return [2 /*return*/];
                }
            });
        });
    };
    NeoLoginErrorHandler.prototype.redirectToHome = function () {
        this.navigationHelper.navigateInternal("/");
    };
    NeoLoginErrorHandler = __decorate([
        injectable(),
        __param(0, inject(NeoTypes.Security.AuthenticationService.symbol)),
        __param(1, inject(NeoTypes.Routing.NavigationHelper.symbol)),
        __metadata("design:paramtypes", [Object, Object])
    ], NeoLoginErrorHandler);
    return NeoLoginErrorHandler;
}());
export { NeoLoginErrorHandler };
